import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import Axios from "axios";
import Localizer from "@Scripts/Common/Localizer";
import FormHelper from "@Scripts/Common/FormHelper";
import CookieHelper from "@Scripts/Infrastructure/CookieHelper";
import FormLegacyHelper from "@Scripts/Infrastructure/FormLegacyHelper";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";

@Component({ name: "NewsletterSubscribe" })
export default class NewsletterSubscribe extends Vue {
    public localizer: any = Localizer;
    public isLoading: boolean = false;
    public isSuccess: boolean = false;
    public isNewsletterInterestsVisible: boolean = false;
    public isPrivacyPolicyShow: boolean = false;
    public privacyPolicy: string = null;
    public newsletterSubscribeSubmit: any = { country: null, interests: [] };
    public validationErrors: any[] = [];
    public interests: any[] = [];
    public countries: any[] = [];
    public randomId: number = null;

    get isNewsletterSubscribeVisible() {
        return this.$store.getters["newsletterStore/isNewsletterSubscribeVisible"];
    }

    @Prop() readonly recaptchaSiteKey: string;
    @Prop() readonly magazine: string;
    @Prop() readonly isNewsletterDisabled: boolean;

    @Watch("isNewsletterSubscribeVisible") async onInfoRequestVisibilityUpdate(newValue: boolean) {
        if (newValue) {
            await Promise.all([this.getData(), this.getPrivacyPolicy()]);
            this.setRecapthca();

            document.body.classList.add("overflow");
            (<any>this).$refs.newsletterSubscribeModal.classList.add("show");
            this.getRandomId();
        } else {
            document.body.classList.remove("overflow");
            (<any>this).$refs.newsletterSubscribeModal.classList.remove("show");
        }
    }

    get routes() {
        return (<any>window).App.routes;
    }

    public created() {
        this.setOpenNewsletterDialog();
    }

    public setRecapthca() {
        let recaptchaScript = document.createElement("script");
        recaptchaScript.setAttribute("src", "https://www.google.com/recaptcha/api.js");
        document.head.appendChild(recaptchaScript);
    }

    public getRandomId() {
        let randomNumber: number;
        randomNumber = Math.floor(Math.random() * 10);
        this.randomId = randomNumber;
    }

    public async getPrivacyPolicy() {
        const result = (await Axios.post(this.routes.Terms_GetNewsletterPrivacyPolicy, null)).data;
        this.privacyPolicy = result.text;
    }

    public async getData() {
        const result = (await Axios.post(this.routes.Newsletter_GetNewsletterSubscribeData, null)).data;
        this.interests = result.interests;
        this.countries = result.countries;
        this.newsletterSubscribeSubmit.interests = result.interests.map(x => x.value);
    }

    public showPrivacyPolicy() {
        if (!this.isPrivacyPolicyShow) {
            this.isPrivacyPolicyShow = true;
        } else {
            this.isPrivacyPolicyShow = false;
        }
    }

    public closeNewsletterSubscribe() {
        this.newsletterSubscribeSubmit = { country: null, interests: [] };
        this.validationErrors = [];
        this.isSuccess = false;
        this.isPrivacyPolicyShow = false;
        CookieHelper.setCookie("nwsl", "nwsl", 30);
        this.$store.commit("newsletterStore/setNewsletterSubscribeVisible", false);
        if (this.magazine) {
            CookieHelper.setCookie("nwslm", "nwslm", 30);
        }
    }

    public showNewsletterInterests() {
        this.isNewsletterInterestsVisible = !this.isNewsletterInterestsVisible;
    }

    public async setNewsletterSubscribeSubmit() {
        FormHelper.removeFocus();
        this.validationErrors = [];
        this.isLoading = true;

        try {
            await Axios.post(this.routes.Newsletter_Subscribe, this.newsletterSubscribeSubmit, { headers: { "RecaptchaVerificationToken": (<any>window).grecaptcha.getResponse() } });

            this.isSuccess = true;
            GTagHelper.sendEvent("form_submit", { newsletter: "success" });
            CookieHelper.setCookie("nwsl", "nwsl", 365);
            CookieHelper.setCookie("nwslm", "nwslm", 365);
        } catch (error) {
            FormLegacyHelper.resetVueValidation();

            if (error.response) {
                if (error.response.status === 400) {
                    let validationState = error.response.data;
                    FormLegacyHelper.setVueValidation(validationState);

                    for (var propertyName in error.response.data) {
                        if (error.response.data.hasOwnProperty(propertyName)) {
                            for (let message of error.response.data[propertyName]) {
                                this.validationErrors.push({ message: message });
                            }
                        }
                    }
                }
            }
            
            (<any>window).grecaptcha.reset();
        }
        
        this.isLoading = false;
    }

    public setOpenNewsletterDialog() {
        if (this.isNewsletterDisabled) {
            return;
        }
        else if (this.$route.query.hasOwnProperty("IsNewsletter")){
            this.$store.commit("newsletterStore/setNewsletterSubscribeVisible", true);
        } else if (this.magazine === "true" && !CookieHelper.getCookie("nwslm")) {
                this.$store.commit("newsletterStore/setNewsletterSubscribeVisible", true);
        } else {
            if (!CookieHelper.getCookie("nwsl")) {
                setTimeout(x => {
                    this.$store.commit("newsletterStore/setNewsletterSubscribeVisible", true);
                }, 5000);
            }
        }
    }

    public closeFancy() {
        CookieHelper.setCookie("nwsl", "nwsl", 365);
        document.location.reload();
    }

    public goHome() {
        parent.window.location.replace("/");
    }
};